<template>
	<div class="news-item">
		<div class="pic">
			<router-link :to="`/newsDetail/${item.id}`">
				<img :src="item.img"
					:alt="`OCM Foods Group  - Asian food wholesale + ${item.title}, 亚洲食品批发-美国华源食品集团 + ${item.title}`">
			</router-link>
		</div>
		<div class="txt type1" v-if="type === 1">
			<p class="sub1-18px">{{$dayjs(item.date).format('MMMM D, YYYY')}}</p>
			<h3 class="h3-24px">{{item.title }}</h3>
			<router-link :to="`/newsDetail/${item.id}`">{{$t('news.view')}} </router-link>
		</div>
		<div class="txt type2" v-if="type === 2">
			<p class="regular-14px">{{$dayjs(item.date).format('MMMM D, YYYY')}}</p>
			<h3>
				<router-link :to="`/newsDetail/${item.id}`" class="h3-24px">{{item.title}}</router-link>
			</h3>
		</div>
	</div>
</template>

<script>
export default {
	name: "newsItem",
	props: {
		item: [Object],
		type: {
			type: [Number],
			default: 1
		}
	}
}
</script>

<style scoped lang="scss">
.news-item {
	width: 0;
	.pic {
		padding-top: 56.25%;
		position: relative;
		overflow: hidden;
		margin-bottom: 24px;
		border-radius: 10px;
		img {
			position: absolute;
			width: 100%;
			height: 100%;
			top: 0;
			left: 0;
			-webkit-transition: all 0.5s;
			-moz-transition: all 0.5s;
			-ms-transition: all 0.5s;
			-o-transition: all 0.5s;
			transition: all 0.5s;
		}
	}
	.pic:hover img {
		-webkit-transform: scale(1.05);
		-moz-transform: scale(1.05);
		-ms-transform: scale(1.05);
		-o-transform: scale(1.05);
		transform: scale(1.05);
	}
	.txt {
		a {
			-webkit-transition: all 0.3s;
			-moz-transition: all 0.3s;
			-ms-transition: all 0.3s;
			-o-transition: all 0.3s;
			transition: all 0.3s;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
			display: block;
		}
		a:hover {
			color: $activeColor;
		}
	}
	.txt.type1 {
		h3 {
			margin: 8px 0 16px;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
		}
		a {
			text-decoration: underline;
		}
	}
	.txt.type2 {
		p {
			margin-bottom: 8px;
		}
	}
}
@media only screen and (max-width: 767px) {
	.news-item .txt.type2 p {
		font-size: 12px;
		margin-bottom: 4px;
	}
	.news-item .txt a {
		font-size: 16px;
	}
	.news-item .txt.type1 {
		.sub1-18px {
			font-size: 12px;
			font-weight: normal;
			opacity: 0.5;
		}
		.h3-24px {
			font-size: 16px;
			margin-top: 4px;
			margin-bottom: 0;
		}
	}
	.news-item .pic {
		margin-bottom: 12px;
	}
}
</style>
